import React from 'react';
import { ArrowRightIcon, ClipboardCheckIcon, ShieldIcon, WrenchIcon } from 'lucide-react';
import { assets, safetyPractices } from '../data/content';
import { SectionLabel } from './SectionLabel';
const icons = [ClipboardCheckIcon, WrenchIcon, ShieldIcon];
export function Safety() {
  return <section id="safety" aria-labelledby="safety-heading" className="ink-surface w-full bg-ink py-20 lg:py-28" data-id="element-198" data-mp="2b03vtdfv4ph9">
      <div className="mx-auto max-w-shell px-5 lg:px-8" data-id="element-199" data-mp="2oyv5mnnozozl">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-16" data-id="element-200" data-mp="2kz2wa8qh5et6">
          <div className="lg:col-span-5" data-id="element-201" data-mp="2kx035fu0z5k8">
            <SectionLabel number="03" tone="light" data-id="element-202" data-mp="2yp69693grw5y">
              Safety
            </SectionLabel>
            <h2 id="safety-heading" className="mt-5 font-display text-[34px] font-semibold uppercase leading-[1.02] text-white sm:text-[44px] lg:text-[50px]" data-id="element-203" data-mp="2ts62bvysipds">
              Safety is part of the work. Every day.
            </h2>
            <img src={assets.worksite} alt="South Lyon Fence project worksite" width={1600} height={813} loading="lazy" decoding="async" className="mt-8 aspect-[4/3] w-full border border-steel/60 object-cover" data-id="element-204" data-mp="2rwx00jllyajk" />
          </div>

          <div className="lg:col-span-7" data-id="element-205" data-mp="35x7tzvi7s58y">
            <p className="max-w-2xl text-base leading-relaxed text-steel-300 sm:text-lg" data-id="element-206" data-mp="35u25oihet7ea">
              Our safety practices include daily toolbox talks, weekly equipment inspections and
              flame-resistant (FR) uniforms. These are part of our commitment to a safe work
              environment for employees and customers.
            </p>

            <ul className="mt-10 grid grid-cols-1 gap-px bg-ink-700 sm:grid-cols-3" data-id="element-207" data-mp="3oluzgf4aywn2">
              {safetyPractices.map((practice, index) => {
              const Icon = icons[index];
              return <li key={practice.title} className="flex flex-col bg-ink p-6" data-id="element-208" data-mp="2g7pf4niucpy" data-mpi={index}>
                    <Icon aria-hidden="true" className="h-6 w-6 text-safety" data-id="element-209" data-mp="1yjvxlxojpbcf" />
                    <h3 className="mt-4 min-h-[3.4rem] font-display text-[21px] font-semibold uppercase leading-tight text-white" data-id="element-210" data-mp="1tk9kdo8pvv3m">
                      {practice.title}
                    </h3>
                    <p className="mt-1 text-[15px] leading-relaxed text-steel-300" data-id="element-211" data-mp="23hfc8yp5nq4w">
                      {practice.body}
                    </p>
                  </li>;
            })}
            </ul>

            <a href="#contact" className="mt-10 inline-flex min-h-[48px] items-center gap-2 font-display text-[17px] uppercase tracking-[0.08em] text-safety transition-colors duration-150 ease-industrial hover:text-white" data-id="element-212" data-mp="2d6p6ol7h1kw6">
              Discuss your site requirements
              <ArrowRightIcon aria-hidden="true" className="h-4 w-4" data-id="element-213" data-mp="wua395ei3o9f" />
            </a>
          </div>
        </div>
      </div>
    </section>;
}